export const Home = require('../../src/front/pages/Top').default;
export const Performance = require('../../src/front/Performance').default;
